import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AllocationContainer from './AllocationContainer';
import { fetchAllAllocationUnits } from 'redux/allocationUnits/AllocationUnitsActions';

const mapStateToProps = ({ allocationUnits }) => ({  
  allocationUnits: allocationUnits.allocationUnits,
  fetchingAllocationUnits: allocationUnits.fetchingAllocationUnits,
});

const mapDispatchToProps = dispatch => ({
  allocationUnitsActions: bindActionCreators( { fetchAllAllocationUnits }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AllocationContainer);


// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditor/comp/ruleBuilder/allocationContainer/AllocationContainerConnector.js